import { axiosGetPost } from '@router/axiosGetPost'

export function downloadRequest(id, modeType) {
  let url = null
  if (modeType.toUpperCase() === 'FCL') {
    url = '/requests/downloadF/'
  } else {
    url = '/requestsLCL/downloadF/'
  }
  axiosGetPost('get', url + id, {}, "Download File Rquests, owner client "+ modeType.toUpperCase()).then((response) => {
    console.log(response)
    let data = response.data
    if (data.success === true) {
      var link = document.createElement('a')
      link.setAttribute('target', '_blank')
      link.href = data.url
      link.click()
      URL.revokeObjectURL(link.href)
    } else {
      this.$toastr.e(
        'Error Download. Status code: ' +
        data.status +
        ' Error: ' +
        data.error
      )
    }
    return data
  })
}
